export const TOKEN_KEY_NAME = "token";
export const REFRESH_TOKEN_KEY_NAME = "refreshToken";
export const NUBETECK_CONFIG_KEY_NAME = "NubeteckConfig";

export * as Tags from "./tags";
export * as Endpoints from "./endpoints";
export * as Permissions from "./permissions";
export * as SettingTypes from "./setting-types";
export * as DataSourceTypes from "./data-source-types";
